import client1 from "../assets/new-images/client/01.jpg";
import client2 from "../assets/new-images/client/02.jpg";
import client3 from "../assets/new-images/client/03.jpg";
import client4 from "../assets/new-images/client/04.jpg";
import client5 from "../assets/new-images/client/05.jpg";
import client6 from "../assets/new-images/client/06.jpg";
import client7 from "../assets/new-images/client/07.jpg";
import client8 from "../assets/new-images/client/08.jpg";

import course1 from "../assets/new-images/course/c1.jpg";
import course2 from "../assets/new-images/course/c2.jpg";
import course3 from "../assets/new-images/course/c3.jpg";
import course4 from "../assets/new-images/course/c4.jpg";
import course5 from "../assets/new-images/course/c5.jpg";
import course6 from "../assets/new-images/course/c6.jpg";
import course7 from "../assets/new-images/course/c7.jpg";
import course8 from "../assets/new-images/course/c8.jpg";
import course9 from "../assets/new-images/course/c9.jpg";
import course10 from "../assets/new-images/course/c10.jpg";

export const courseListing = [
  {
    id: 1,
    image: course1,
    image2: client1,
    name: "Calvin Carlo",
    role: "Professor",
    field: "Digital Marketing",
    desc: "Starting SEO as your Home Based Business",
  },
  {
    id: 2,
    image: course2,
    image2: client2,
    name: "Christa Smith",
    role: "Professor",
    field: "Engineering",
    desc: "Java Programming Masterclass for Software",
  },
  {
    id: 3,
    image: course3,
    image2: client3,
    name: "Jani Jangad",
    role: "Professor",
    field: "Engineering",
    desc: "Microsoft Excel - Excel from Beginner to Advanced",
  },
  {
    id: 4,
    image: course4,
    image2: client4,
    name: "John Cartwright",
    role: "Professor",
    field: "Web Development",
    desc: "Vue - The Complete Guide (w/ Router, Composition API)",
  },
  {
    id: 5,
    image: course5,
    image2: client5,
    name: "Sally Short",
    role: "Professor",
    field: "Front-end Design",
    desc: "HTML, CSS, Javascripts, and Basic Knowledge about web design",
  },
  {
    id: 6,
    image: course6,
    image2: client6,
    name: "William Benson",
    role: "Professor",
    field: "Back-end Development",
    desc: "C Programming For Beginners - Master the C Language",
  },
  {
    id: 7,
    image: course7,
    image2: client7,
    name: "Christa Smith",
    role: "Professor",
    field: "Engineering",
    desc: "Java Programming Masterclass for Software",
  },
  {
    id: 8,
    image: course8,
    image2: client8,
    name: "Jani Jangad",
    role: "Professor",
    field: "Engineering",
    desc: "Microsoft Excel - Excel from Beginner to Advanced",
  },
  {
    id: 9,
    image: course9,
    image2: client1,
    name: "John Cartwright",
    role: "Professor",
    field: "Web Development",
    desc: "Vue - The Complete Guide (w/ Router, Composition API)",
  },
  {
    id: 10,
    image: course10,
    image2: client2,
    name: "Sally Short",
    role: "Professor",
    field: "Front-end Design",
    desc: "HTML, CSS, Javascripts, and Basic Knowledge about web design",
  },
];

export const footerLinks = [
  {
    liClass: "ms-0",
    route: "/terms",
    title: "Terms of Services",
  },
  {
    liClass: "mt-[10px] ms-0",
    route: "/policy-refund",
    title: "Refund Policy",
  },
  {
    liClass: "mt-[10px] ms-0",
    route: "/privacy-policy",
    title: "Privacy Policy",
  },
  {
    liClass: "mt-[10px] ms-0",
    route: "/contact",
    title: "Contact",
  },
  {
    liClass: "mt-[10px] ms-0",
    route: "/contactsales",
    title: "Talk To Sales",
  },
  {
    liClass: "mt-[10px] ms-0",
    route: "/contactsupport",
    title: "Support",
  },
  {
    liClass: "mt-[10px] ms-0",
    route: "/changelog",
    title: "Changelog",
  },
];

export const footerCompany = [
  {
    liClass: "ms-0",
    route: "/about",
    title: "About",
  },
  // {
  //     liClass: 'mt-[10px] ms-0',
  //     route: '/brand',
  //     title: 'Brand',

  // },
  {
    route: "/partners",
    title: "Partners",
    liClass: "mt-[10px] ms-0",
  },
  {
    route: "/pricing",
    title: "Pricing",
    liClass: "mt-[10px] ms-0",
  },
  {
    route: "/careers",
    title: "Careers",
    liClass: "mt-[10px] ms-0",
  },

  // {
  //     route: '/waitlist',
  //     title: 'Waitlist',
  //     liClass: 'mt-[10px] ms-0',

  // }
];
